module.exports = __webpack_public_path__ + "img/no-poster.34efc47c.svg";